import { RoutingResultType } from '../shared/index.js';
export { RoutingResultType };
//# sourceMappingURL=routing.js.map